module.exports = "/images/vendor/flag-icon-css/flags/4x3/ax.svg?c26f83744d3df6899632e575d390681a";